import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAspectRatio219: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="aspect-ratio-21-9, wide, landscape" maskId="round-filled-radius-1-stroke-1.5-IconAspectRatio219"><path d="M1.75 6C0.783502 6 0 6.7835 0 7.75V16.25C0 17.2165 0.783502 18 1.75 18H22.25C23.2165 18 24 17.2165 24 16.25V7.75C24 6.7835 23.2165 6 22.25 6H1.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAspectRatio219;
